import type { ValueOf } from '@shared/lib'

export const ButtonVariant = {
  primary: 'primary',
  /** Зелёная градиентная — «Приступить к олимпиаде» (499:139099) */
  success: 'success',
  outline: 'outline',
  destructive: 'destructive',
  ghost: 'ghost',
  secondary: 'secondary',
  link: 'link',
} as const
export type ButtonVariant = ValueOf<typeof ButtonVariant>

export const ButtonSize = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
} as const
export type ButtonSize = ValueOf<typeof ButtonSize>
